module.exports = __webpack_public_path__ + "static/media/goal.1f0124ea.svg";